var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 40,
    viewBox: "0 0 119 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9715 9.7998L19.5972 23.4L9.22192 37.0002H23.0553L33.4306 23.4L43.8049 9.7998H29.9715Z",
    fill: "#009F75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.903 23.3994L32.2772 36.9996H29.9715L19.5972 23.3994H21.903Z",
    fill: "#03E287"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6668 23.3994L38.0411 36.9996H35.7364L25.3611 23.3994H27.6668Z",
    fill: "#03E287"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8049 36.9996H41.5002L31.1249 23.3994H33.4306L43.8049 36.9996Z",
    fill: "#03E287"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2077 3H10.3753L0 16.6002H8.35792L3.45809 35.8671L24.2077 8.66667H19.8856L24.2077 3Z",
    fill: "#03E287"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7764 16.3242C72.5026 16.3757 73.8228 17.7797 73.8228 20.327V27.2152H69.0875V21.3146C69.0875 20.6909 68.686 20.3528 67.9971 20.3528H61.5401V27.2152H56.8049V9.7998H61.5401V16.3242H64.6679L69.0299 9.7998H74.2243L69.7764 16.3242Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0658 9.7998H102.145L96.8361 27.2152H91.5274L88.6292 17.2859L85.6734 27.2152H80.3646L75.0558 9.7998H80.1067L83.3205 20.4311L86.4199 9.7998H90.8395L90.8112 9.85135L93.8814 20.4043L97.0668 9.7998H97.0658Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M103.579 27.2152V9.7998H118.559V13.9583H108.314V16.454H117.124V20.3528H108.314V23.0557H118.559V27.2142H103.579V27.2152Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M62.25 31.1924H63.1591V36.8817H62.25L58.4165 32.2799V36.8817H57.5074V31.1924H58.6231L62.2511 35.4715V31.1924H62.25Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M68.924 35.0646H65.0905C65.1566 35.7181 65.7563 36.2274 66.5993 36.2274C67.1991 36.2274 67.6961 35.9728 67.9027 35.5738H68.8306C68.5213 36.4655 67.65 37.0005 66.5627 37.0005C65.0632 37.0005 64.1447 35.982 64.1447 34.7842C64.1447 33.5863 65.1199 32.5596 66.5448 32.5596C68.082 32.5596 69.0477 33.6636 68.9261 35.0646H68.924ZM65.1083 34.3512H67.9583C67.8178 33.7482 67.2641 33.3327 66.5239 33.3327C65.7836 33.3327 65.2394 33.7574 65.1083 34.3512Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2261 33.4592H71.1175V35.6756C71.1175 35.9384 71.2863 36.092 71.5862 36.092H73.2272V36.8817H71.409C70.6499 36.8817 70.2284 36.5085 70.2284 35.8292V33.4602H69.3843V32.6788H70.2284V31.1934H71.1186V32.6788H73.2272V33.4602L73.2261 33.4592Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M79.769 32.6787H80.7253L79.1787 36.8816H78.2885L77.2106 33.8333L76.1516 36.8816H75.2519L73.7053 32.6787H74.671L75.7301 35.727L76.7796 32.6787H77.651L78.71 35.7352L79.769 32.6787Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0996 34.7759C81.0996 33.5358 82.1031 32.5596 83.6119 32.5596C85.1208 32.5596 86.0865 33.5358 86.0865 34.7759C86.0865 36.0161 85.0925 37.0005 83.6119 37.0005C82.1314 37.0005 81.0996 36.0068 81.0996 34.7759ZM85.1963 34.7759C85.1963 33.978 84.5587 33.3327 83.6119 33.3327C82.6651 33.3327 81.9993 33.978 81.9993 34.7759C81.9993 35.5738 82.6368 36.2284 83.6119 36.2284C84.5871 36.2284 85.1963 35.5666 85.1963 34.7759Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M90.267 32.6787V33.4941H89.3862C88.5422 33.4941 87.9707 33.9951 87.9707 34.8611V36.8816H87.0805V32.6787H87.9424V33.4003H87.9802C88.2234 32.9251 88.711 32.6787 89.3768 32.6787H90.267Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M94.307 34.2745C94.954 34.325 95.3189 34.6735 95.3189 35.3023V36.8816H94.4287V35.4384C94.4287 35.1755 94.2504 35.0312 93.96 35.0312H91.973V36.8826H91.0828V30.7686H91.973V34.2673H93.3224L94.372 32.6798H95.3472L94.307 34.2766V34.2745Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/LOGO.96126233c36c82aec3690101d6812a7b.svg";
export { ForwardRef as ReactComponent };